var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"summary-section-button search",on:{"click":function($event){$event.stopPropagation();return _vm.onClickSearch(_vm.search)}}},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"search-title"},[_vm._v(" "+_vm._s(_vm.search)+" ")]),_c('img',{staticClass:"right",attrs:{"height":"25","src":"/search.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }